import { Card } from "@verde/compose-ui";
import type { FetchClient, RatingV2 } from "@verde/entities";
import { ExternalLinkIcon } from "@verde/icons";
import { People } from "@verde/modules";
import { Alert, Button, Progress } from "@verde/ui-core";
import React from "react";
import { useNavigate } from "react-router-dom";

interface CreditProfileRatingProps {
  rating?: RatingV2;
  client?: FetchClient;
  updating?: boolean;
  creditUsageId?: number;
}

function CreditProfileRating({
  rating,
  client,
  updating,
  creditUsageId,
}: CreditProfileRatingProps) {
  const navigate = useNavigate();

  if (updating) {
    return (
      <div className="grid gap-6 rounded border border-neutral-light-2 bg-neutral-light-1 p-6">
        <div className="grid gap-1">
          <p className="text-lg font-semibold">Calculando Rating...</p>
          <p className="font-medium">
            Ao atualizar a consulta dos dados do produtor, o perfil de crédito
            Verde também é atualizado. O resultado da qualificação pode levar
            até 2 minutos, notificaremos assim que tudo estiver pronto.
          </p>
        </div>

        <Progress kind="infinite" />
      </div>
    );
  }

  return (
    <>
      {!!rating?.id && (
        <div className="grid grid-cols-[1.5fr_1fr] gap-4">
          {rating && <People.RatingOverview rating={rating} />}
          {client?.id && (
            <People.DebtsSummaryWidget
              client_id={client.id}
              creditUsageId={creditUsageId}
            />
          )}
        </div>
      )}

      {!rating?.id && (
        <Card
          title="Rating Verde"
          classNames={{
            base: "border",
          }}
        >
          <Alert
            classNames={{
              base: "p-4",
            }}
          >
            <div className="flex items-center gap-2">
              <p className="flex-1">
                Calcule a capacidade de pagamento desse produtor declarando os
                dados de suas áreas, sua receita e produção. Para isso, crie uma
                proposta de financiamento e cadastre os dados solicitados.
              </p>

              <Button
                size="lg"
                icon={<ExternalLinkIcon />}
                onClick={() => {
                  navigate(`/clientes/${client?.id}/qualificacao`);
                }}
              >
                Calcular
              </Button>
            </div>
          </Alert>
        </Card>
      )}
    </>
  );
}

export default React.memo(CreditProfileRating);
